import { useUserSession } from '../../models/hooks/appStateHooks';

export const useRealtimeCoachingEnabled = () => {
	const userSession = useUserSession();
	return (
		(userSession.account?.isLevitateSalesCoffeeAccount ?? false) ||
		(userSession.user?.userPreferences?.coffeePreferences?.realtimeCoachingEnabled ?? false)
	);
};
